import useSWRImmutable from 'swr/immutable'

import { useSession } from '@/legacy-src/contexts/session-context'

import { useApis } from '../../../contexts/api-context'
import { type ExtendedDiagnosisResponse } from '../../diagnosis/client/types'

const fetchDiagnosis = async (api, serviceId?): Promise<ExtendedDiagnosisResponse> => {
  const res = await api.getDiagnosis(serviceId)
  return res.data
}

const useGetDiagnosis = (serviceId?: number) => {
  const { api } = useApis()
  const { isLoggedIn } = useSession()

  const { data, mutate, isLoading } = useSWRImmutable(isLoggedIn ? ['useGetDiagnosis', serviceId] : null, () =>
    fetchDiagnosis(api, serviceId),
  )

  return { data, isLoading, refetchDiagnosis: mutate }
}

export default useGetDiagnosis
